module.exports = __webpack_public_path__ + "img/4a5aad11a457ccef83d14e6e5aa708c5.6df04456.png";